import api from '@/api';

import { API_BASE_URL } from '..';
import { Material, MaterialListRequest } from './Material.types';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}/materials`;

export async function materialList(params?: MaterialListRequest) {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResultStock<Material>;
}
